import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

import Navigation from './../components/Navigation';
import HeroAria from './../components/HeroAria';
import About from './../components/About';
import Story from './../components/Story';
import Pricing from './../components/Pricing';
import Gallery from './../components/Gallery';
import CallToAction from './../components/CallToAction';
import Service from './../components/Service';
import Footer from './../components/Footer';
import Contact from './../components/Contact';
import ContactForm from './../components/ContactForm';
import Amenities from './../components/Amenities';

// 🔹 Animation configs
const pageVariants = {
  initial: { opacity: 0, scale: 0.95 },
  in: { opacity: 1, scale: 1 },
  out: { opacity: 0, scale: 0.95 },
};

const pageTransition = {
  duration: 0.5,
  ease: "easeInOut",
};

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // 🔹 Scroll to section based on hash if present
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth" });
        }, 300); // wait for animation to complete
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    // <motion.div
    //   initial="initial"
    //   animate="in"
    //   exit="out"
    //   variants={pageVariants}
    //   transition={pageTransition}
    // >
    <>
      <Navigation />
      <HeroAria />
      <About />
      <Story />
      <Service />
      <Pricing />
      <Amenities />
      <Gallery />
      <ContactForm />
      <Footer />
    {/* // </motion.div> */}
    </>
  );
};

export default Home;
